// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDleYtnuTM5lpSx09GXhNBYpWYwEy3dQvY",
    authDomain: "ecodash-v2.firebaseapp.com",
    projectId: "ecodash-v2",
    storageBucket: "ecodash-v2.appspot.com",
    messagingSenderId: "795009841659",
    appId: "1:795009841659:web:8b1eba6f3a7dba77f3f35e",
    measurementId: "G-YNJT7E0XE1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Set Auth Persistence to Local (Prevents Logout on Refresh)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("🔥 Auth persistence set to LOCAL (stays logged in on refresh)");
  })
  .catch((error) => {
    console.error("❌ Error setting auth persistence:", error);
  });

export { db, auth };
